import React, { useEffect, useState } from 'react'
import { GiCancel } from 'react-icons/gi';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { TiSpanner } from 'react-icons/ti';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCheckupReportApi } from '../../service/api/homeMaintenance/getCheckupReport';
import searchImg from '../../media/images/servicesAssets/searchImg.png'
import { Modal, Spinner } from 'react-bootstrap';
import { MdOutlineCancel } from 'react-icons/md';
import { LuArrowUpDown } from 'react-icons/lu';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaSearch } from 'react-icons/fa';
import { getHomeMaintenancePlansApi } from '../../service/api/homeMaintenance/getHomeMaintenancePlans';

const CheckUpResults = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [checkUpTabsToggle, setCheckUpTabsToggle] = useState(4);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [columnName, setColumnName] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);

    const [checkupResultsArr, setCheckupResultsArr] = useState([]);
    const [checkupResultCompleteObj, setCheckupResultCompleteObj] = useState({});

    const [maintenanceObj, setMaintenanceObj] = useState({});

    const [isExpandedForProduct, setIsExpandedForProduct] = useState("");

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);
    const [flag, setFlag] = useState(false);

    const handleCheckUpTabs = (val) => {
        setCheckUpTabsToggle(val)
    }
    const backToPrevious = () => {
        navigate(-1)
    }

    const getCheckupReportFn = () => {
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("condition_int", checkUpTabsToggle);
        data.append("pagination_flag", 0);
        // data.append("page_index", page);
        // data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);


        dispatch(
            getCheckupReportApi(data, (res) => {
                setCheckupResultCompleteObj(res)
                setCheckupResultsArr(res?.data)
            }, (err) => { })
        );
    };

    useEffect(() => {
        getCheckupReportFn();
    }, [checkUpTabsToggle, filtreValue]);

    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? "am" : "pm";
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const [imageAttachURL, setImageAttachURL] = useState('');
    const [openDoc, setOpenDoc] = React.useState(false);
    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);



    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }


    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    const handleSearch = (e) => {
        // setPage(1)
        setPage(1);
        if (searchValue.trim().length >= 2) {
            setColumnName("");
        }
        setSearchValue(e.target.value);
    };

    useEffect(() => {
        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(getCheckupReportFn, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
            if (flag) {

                getCheckupReportFn();
            }
        }
    }, [searchValue]);

    const getHomeMaintenancePlansFn = () => {
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("pagination_flag", 0);
        // data.append("condition_int", checkUpTabsToggle);
        // data.append("page_index", page);
        // data.append("page_size", pageSize);
        // data.append("sorting_order", sortByValue);
        // data.append("sorting_column_name", columnName);
        // data.append("search_area", searchValue);
        dispatch(
            getHomeMaintenancePlansApi(data, (res) => {
                setMaintenanceObj(res)
            }, (err) => { })
        );
    };

    useEffect(() => {
        getHomeMaintenancePlansFn();
    }, []);

    return (
        <>
            < div className="row d-flex justify-content-center align-items-center" >
                <div className="col mx-3 align-items-center">

                    <div className="row mx-0">
                        <div className='col-12 d-flex'>
                            <div onClick={() => backToPrevious()} className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w500 cursor-pointer rounded-1 mb-1 d-flex align-items-center'>
                                <i class="bi bi-arrow-left-short pe-2"></i>
                                <span>{"Back"}</span>
                            </div>
                        </div>
                    </div>


                    <div className="row mx-0">
                        <div className="col-12 px-2">
                            <div>

                                <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 d-flex  align-items-center justify-content-center">
                                        <span className="fs-3 font-w700 text-center text-black">
                                            {'Check-Up results'}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0">
                                    <div className="col-12 px-0 d-flex align-items-center justify-content-center">
                                        <span className="fs-5 font-w600 text-center">
                                            {'Review the check-up results to know everything about the current condition of your inventory items and the upcoming maintenance tasks'}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 my-4 ">
                                    <div className='col-12 p-1 bg-white rounded-2 shadow-lg'>
                                        <div className='row mx-0'>
                                            <div className='col-12 p-2 d-flex justify-content-center align-items-center'>
                                                <span className='fs-5 font-w600'>
                                                    {`Maintenance Tasks`}
                                                </span>
                                            </div>
                                        </div>

                                        <div className='row mx-0'>
                                            <div
                                                className='border-3 border-right col-6'
                                                style={{ borderColor: '#e7e1e1' }}
                                            >
                                                <div className='row mx-0'>
                                                    <div
                                                        className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                        style={{ background: 'rgba(79, 93, 116, 1)' }}
                                                    >
                                                        <span className='fs-6 font-w600 text-white text-center'>
                                                            {`Total Tasks`}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0'>
                                                    <div
                                                        className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                        style={{}}
                                                    >
                                                        {Object.keys(maintenanceObj).length > 0 ?
                                                            <span className='fs-2 font-w600'>
                                                                {`${maintenanceObj?.total_count || 0}`}
                                                            </span> :
                                                            <Spinner size="md"  />
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-6'>
                                                <div className='row mx-0'>
                                                    <div
                                                        className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                        style={{ background: 'rgba(79, 93, 116, 1)' }}
                                                    >
                                                        <span className='fs-6 font-w600 text-white text-center'>
                                                            {`Tasks in Next 30 days`}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0'>
                                                    <div
                                                        className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                        style={{}}
                                                    >
                                                        {Object.keys(maintenanceObj).length > 0 ?
                                                            <span className='fs-2 font-w600'>
                                                                {`${maintenanceObj?.home_maintenance_plan_in_30_days_count || 0}`}
                                                            </span> :
                                                            <Spinner size="md" />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='row mx-0'>
                                            <div
                                                onClick={() => navigate('/maintenanceTasks')}
                                                className='col-12 p-2 d-flex justify-content-center align-items-center text-hovered cursor-pointer overlay-action-btn rounded-bottom'
                                                style={{ background: 'rgba(244, 248, 255, 1)' }}
                                            >
                                                <div>
                                                    <span className='fs-5 font-w600'>
                                                        {`View all`}
                                                    </span>
                                                    <span>
                                                        <i className='bi bi-chevron-right ps-2'></i>
                                                    </span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row mx-0 mb-2'>
                                    <div className='col-12 px-0'>
                                        <span className='fs-5 font-w600'>
                                            {'Items conditions'}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0'>

                                        <div className='row mx-0'>
                                            <div className='col-12 px-0 d-flex border-bottom overflow-auto'>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(4)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white '
                                                        style={{
                                                            background: 'rgba(79, 93, 116, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`All`}</span>
                                                    </div>
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-4 w-100 font-w600'
                                                        style={{
                                                            background: checkUpTabsToggle === 4 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        <span>{checkupResultCompleteObj?.all_items_count || 0}</span>
                                                    </div>

                                                </div>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(1)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white'
                                                        style={{
                                                            background: 'rgba(45, 204, 99, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`Good`}</span>
                                                    </div>
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-4 w-100 font-w600'
                                                        style={{
                                                            background: checkUpTabsToggle === 1 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        <div>
                                                            <span className='me-2'>
                                                                <IoCheckmarkCircleOutline />
                                                            </span>
                                                            <span>{checkupResultCompleteObj?.good_items_count}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(2)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white'
                                                        style={{
                                                            background: 'rgba(255, 154, 32, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`OK`}</span>
                                                    </div>
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-4 w-100 font-w600'
                                                        style={{
                                                            background: checkUpTabsToggle === 2 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        <div>
                                                            <span className='me-2'>
                                                                <TiSpanner className='rounded-circle border border-2' />
                                                            </span>
                                                            <span>{checkupResultCompleteObj?.ok_items_count}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(3)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white'
                                                        style={{
                                                            background: 'rgba(240, 72, 72, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`Poor`}</span>
                                                    </div>
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-4 w-100 font-w600'
                                                        style={{
                                                            background: checkUpTabsToggle === 3 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        <div>
                                                            <span className='me-2'>
                                                                <MdOutlineCancel />
                                                            </span>
                                                            <span>{checkupResultCompleteObj?.poor_items_count}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div
                                            className="row  px-2 "
                                            style={{
                                                backgroundColor: "rgba(251, 252, 255, 1)",
                                            }}
                                        >

                                            <div
                                                className="row mx-0 my-2 align-items-center "
                                                style={{ minHeight: "40px" }}
                                            >
                                                <div className="col-12">
                                                    <div className="row">
                                                        <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                                            <span className="fs-5 p-2 d-flex align-items-center">
                                                                <LuArrowUpDown
                                                                    className="pointer"
                                                                    style={{ marginRight: "4px", color: "black" }}
                                                                    onClick={handleOpenFiltreBox}
                                                                />
                                                                <span
                                                                    className="fs-6  pointer"
                                                                    style={{ position: "relative" }}
                                                                    onClick={handleOpenFiltreBox}>
                                                                    {filtreValue == 1 && "Date: Newest first"}
                                                                    {filtreValue == 2 && "Date: Oldest first"}

                                                                    &nbsp;
                                                                    {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                                    <span
                                                                        className={`${filtreBox ? "" : "d-none"} p-3`}
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "26px",
                                                                            width: "170px",
                                                                            zIndex: 1,
                                                                            border: "1px solid lightgray",
                                                                            background: "white",
                                                                            right: "0",
                                                                            boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                                        }}>
                                                                        <div className="row">
                                                                            <div
                                                                                className={`${filtreValue == 1 ? "dt" : ""
                                                                                    } d-flex justify-content-start m-1 pointer `}
                                                                                onClick={() => {
                                                                                    handleSetFiltreValue(1);
                                                                                }}>
                                                                                <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                                    {filtreValue == 1 && <i className="bi bi-check-lg"></i>}
                                                                                </div>
                                                                                Date: Newest first
                                                                            </div>
                                                                            <div
                                                                                className={`${filtreValue == 2 ? "dt" : ""
                                                                                    } d-flex justify-content-start m-1 pointer`}
                                                                                onClick={() => {
                                                                                    handleSetFiltreValue(2);
                                                                                }}>
                                                                                <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                                    {filtreValue == 2 && <i className="bi bi-check-lg"></i>}
                                                                                </div>
                                                                                Date: Oldest first
                                                                            </div>

                                                                        </div>
                                                                    </span>
                                                                </span>
                                                            </span>

                                                            <span
                                                                className="fs-6 p-2 d-flex align-items-center"
                                                                style={{
                                                                    border: "1px solid lightgray",
                                                                    borderRadius: "6px",
                                                                }}>
                                                                <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                                <input
                                                                    placeholder="Search"
                                                                    style={{ border: "0px", width: "100%" }}
                                                                    onChange={handleSearch}
                                                                    value={searchValue}
                                                                />
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='row mx-0 mb-3'>
                                            <div className='col-12 px-0'>
                                                {checkupResultsArr.length > 0 ?
                                                    <>
                                                        {checkupResultsArr?.map((item, ind) => {
                                                            return (
                                                                <>
                                                                    <div
                                                                        key={ind}
                                                                        className="row mx-0 "
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                        }}
                                                                        style={{ cursor: 'default' }}
                                                                    >
                                                                        <div
                                                                            className="col-12 px-3 border-top"
                                                                            style={{
                                                                                background: 'rgb(199 212 234 / 30%)',
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="d-flex align-items-center justify-content-between w-100 py-3 font-w600 cursor-pointer text-black text-hovered"
                                                                                onClick={() => {
                                                                                    if (item?.home_area_product_id_ids === isExpandedForProduct) {
                                                                                        setIsExpandedForProduct('')
                                                                                    } else {
                                                                                        setIsExpandedForProduct(item?.home_area_product_id_ids)
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <div className="me-4 d-flex">
                                                                                    <div className='me-3 position-relative'>
                                                                                        <div className='position-absolute'
                                                                                            style={{
                                                                                                top: '-15px',
                                                                                                right: '-5px',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                item?.condition_chr === "Good" ?
                                                                                                    <IoCheckmarkCircleOutline
                                                                                                        style={{ height: '18px', width: '18px', color: 'rgba(45, 204, 99, 1)' }}
                                                                                                        className='bg-white rounded-circle shadow'
                                                                                                    /> :
                                                                                                    item?.condition_chr === "Ok" ?
                                                                                                        <TiSpanner
                                                                                                            style={{ height: '18px', width: '18px', color: 'rgba(255, 154, 32, 1)', border: '1px solid rgba(255, 154, 32, 1)' }}
                                                                                                            className='bg-white rounded-circle shadow'
                                                                                                        /> :
                                                                                                        item?.condition_chr === "Poor" ?
                                                                                                            <MdOutlineCancel
                                                                                                                style={{ height: '18px', width: '18px', color: 'rgba(240, 72, 72, 1)' }}
                                                                                                                className='bg-white rounded-circle shadow'
                                                                                                            /> : ''
                                                                                            }
                                                                                        </div>
                                                                                        <span
                                                                                            className=" p-2 rounded bg-white shadow-lg text-black"
                                                                                        >
                                                                                            <i
                                                                                                class="bi bi-cloud-hail-fill"
                                                                                                style={{ height: '20px', width: '20px' }}
                                                                                            ></i>
                                                                                        </span>
                                                                                    </div>

                                                                                    <span>{`${item?.product_name_chr}`}</span>
                                                                                </div>

                                                                                <div
                                                                                    className="text-black fs-4 d-flex align-items-center justify-content-center cursor-pointer"
                                                                                >
                                                                                    <span>
                                                                                        <span>
                                                                                            <span>
                                                                                                {item.home_area_product_id_ids === isExpandedForProduct ?
                                                                                                    <i class="bi bi-chevron-up ms-2 border rounded px-1 text-hovered overlay-action-btn"></i> :
                                                                                                    <i class="bi bi-chevron-down ms-2 border rounded px-1 text-hovered overlay-action-btn"></i>
                                                                                                }
                                                                                            </span>
                                                                                        </span>
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            {item?.home_area_product_id_ids === isExpandedForProduct &&
                                                                                <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                                                    <div className="col-12 p-1">
                                                                                        <div className="row mx-1 pb-1 pt-2 px-3 d-flex align-items-center">
                                                                                            <div className="col-4 pe-2  font-w500">
                                                                                                <span>{`Condition`}</span>
                                                                                            </div>
                                                                                            <div className="col-8 d-flex">
                                                                                                <span
                                                                                                    className="text-white rounded-pill p-1 px-3"
                                                                                                    style={{
                                                                                                        background:
                                                                                                            `${item?.condition_chr === "Good" ? "rgba(45, 204, 99, 1)" :
                                                                                                                item?.condition_chr === "Ok" ? "rgba(255, 154, 32, 1)" :
                                                                                                                    item?.condition_chr === "Poor" ? "rgba(240, 72, 72, 1)" :
                                                                                                                        item?.condition_chr === "Not assessed" ? "rgba(131, 154, 192, 1)" : ''}`,
                                                                                                    }}
                                                                                                >
                                                                                                    {`${item?.condition_chr}`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="row mx-1 py-2 px-3 border-bottom  d-flex align-items-center">
                                                                                            <div className="col-4 pe-2  font-w500">
                                                                                                <span>{`Updated`}</span>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                <span className="text-black font-w600 p-1 px-2">{`${formatUnixTimestamp(item?.updated_date_dtm)}`}</span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                            <div className="col-4 pe-2 font-w500">
                                                                                                <span>{`Brand`}</span>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                <span className={`${item?.device_brand_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.device_brand_chr ? item?.device_brand_chr : 'NA'}`}</span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                            <div className="col-4 pe-2 font-w500">
                                                                                                <span>{`Model`}</span>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                <span className={`${item?.model_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.model_number_chr ? item?.model_number_chr : 'NA'}`}</span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                            <div className="col-4 pe-2 font-w500">
                                                                                                <span>{`Serial number`}</span>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                <span className={`${item?.serial_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.serial_number_chr ? item?.serial_number_chr : 'NA'}`}</span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                            <div className="col-4 pe-2 font-w500">
                                                                                                <span>{`Description`}</span>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                <span className={`${item?.description_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.description_chr ? item?.description_chr : 'NA'}`}</span>
                                                                                            </div>
                                                                                        </div>

                                                                                        {item?.image_url &&
                                                                                            <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                                <div className="col-12">
                                                                                                    <img
                                                                                                        src={item?.image_url}
                                                                                                        alt="Attachment"
                                                                                                        className="rounded-2 shadow-lg cursor-pointer"
                                                                                                        onClick={(e) => {
                                                                                                            handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                                                        }}
                                                                                                        style={{
                                                                                                            height: '60px',
                                                                                                            width: '60px',
                                                                                                            border: '1px solid orange'
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </> :
                                                    <>
                                                        <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                            <div className="mb-2">
                                                                <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                            </div>
                                                            <span>
                                                                {`No items found`}
                                                            </span>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* Modal for previewing the attached image preview */}
            <>
                <Modal show={openDoc} onHide={handleCloseDoc} centered style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={imageAttachURL} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>

                    <>
                        <img src={imageAttachURL} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>
        </>
    )
}

export default CheckUpResults;